import { render, staticRenderFns } from "./ServiceInfoHeader.vue?vue&type=template&id=2720e9b6&scoped=true&"
import script from "./ServiceInfoHeader.vue?vue&type=script&lang=js&"
export * from "./ServiceInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfoHeader.vue?vue&type=style&index=0&id=2720e9b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720e9b6",
  null
  
)

export default component.exports